import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbDropdownModule, NgbModalModule, NgbProgressbarModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ENVIRONMENT } from './core/models/environment.model';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbProgressbarModule,
    NgbToastModule,
    TranslateModule.forRoot({
      fallbackLang: 'ja',
      loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    }),
    CoreModule,
    AppRoutingModule,
  ],
  providers: [{ provide: ENVIRONMENT, useValue: environment }, provideHttpClient(withInterceptorsFromDi())],
})
export class AppModule {}
